import { createFileRoute, notFound } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import config from '@@config';
import { textSearchParams } from '@@containers/Search/unitySearchParams';
import { requireRoles } from '@@router/guards';
import { getContentLocale, useSettingsStore } from '@@scripts/store/settings/useSettingsStore';

import { geneeaEntityListQuery } from './-components/geneeaEntityListQuery';
import { Layout } from './-components/Layout';

const requireGeneeaEntityRoles = requireRoles(config.navigation.geneeaEntities.authorize);

export const Route = createFileRoute('/_authenticated/geneea-entities')({
    validateSearch: textSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => textSearchParams.parse(search),
    beforeLoad: ({ search }) => {
        requireGeneeaEntityRoles();

        // A beta feature, for users who turned beta features on
        if (!useSettingsStore.getState().betaFeaturesEnabled) {
            throw notFound();
        }

        const contentLocale = getContentLocale();

        // Built on every load, so the options follow the content language as well as the search
        return {
            allEntitiesQuery: geneeaEntityListQuery({ q: search.q }, contentLocale),
            assignedEntitiesQuery: geneeaEntityListQuery(
                { q: search.q, hasTag: true },
                contentLocale,
            ),
            unassignedEntitiesQuery: geneeaEntityListQuery(
                { q: search.q, hasTag: false },
                contentLocale,
            ),
        };
    },
    // Every tab's query runs, for their counts
    loader: ({ context }) => {
        context.queryClient.infiniteQuery(context.allEntitiesQuery).catch(doNothing());
        context.queryClient.infiniteQuery(context.assignedEntitiesQuery).catch(doNothing());
        context.queryClient.infiniteQuery(context.unassignedEntitiesQuery).catch(doNothing());
    },
    component: Layout,
});
